export default {
  data() {
    return {
      sidebar: '2',
      keyChange: 0,
      props: {
        'name': 'BlogSearchComponent',
        'width': '920px',
        'height': '50px',
        'zIndex': 'auto',
        'border': '0 none #000000',
        'boxShadow': '0 0 0 0 black initial',
        'borderRadius': '0 0 0 0',
        'paddingTop': '0px',
        'paddingLeft': '15px',
        'showLabel': true,
        'showPlaceholder': true,
        'paddingRight': '15px',
        'paddingBottom': '15px',

        'backgroundColor': '#d0d0d0',
        'backgroundColorHover': '#dfdfdf',

        'maxWidth': '500px',

        'showDesktop': true,
        'showMobile': true,
      },
      internal_config: {
        placeholder: 'Search',
        'width': '50px',
        'height': '50px',
        lbltext: 'search',
        btnText: 'search',
        'zIndex': 'auto',
        'border': '0 none #000000',
        'boxShadow': '0 0 0 0 black initial',
        'borderRadius': '0 0 0 0',
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
        'colorDetails': '#5AD67D',
        'colorReadMore': '#5AD67D',
        'colorTitle': '#000',
        'colorSubTitle': '#ddd',

        'backgroundColor': '#FFFFFF',
        'backgroundColorHover': '#dfdfdf',


        'showLabel': true,
        'showPlaceholder': true,
        'titleStyle': {
          'family': 'Lato, sans-serif',
          'size': '25px',
          'sizeMobile': '15px',
          'color': 'black',
          'align': 'left',
          'weight': '400',
          'style': 'initial',
          'stroke': 'none'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/apps/Blog/Search/Model.js